import Vue from 'vue'
import Router from 'vue-router'
import LearningScreen from '@/components/LearningScreen'
import StatsScreen from '@/components/StatsScreen'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // Dev only: in production Pages serves `/` as the marketing page.
    {
      path: '/',
      redirect: '/practice'
    },
    {
      path: '/watch',
      redirect: function (to) { return { path: '/practice', query: to.query } }
    },
    // Share links get their own path so the preview Pages Function (functions/s.js)
    // only owns /s. No beforeEnter here or on /practice: shared links must land on the sentence.
    {
      path: '/s',
      redirect: function (to) { return { path: '/practice', query: to.query } }
    },
    {
      path: '/shorts/:id',
      redirect: function (to) { return { path: '/practice', query: Object.assign({ v: to.params.id }, to.query) } }
    },
    {
      path: '/practice',
      name: 'LearningScreen',
      component: LearningScreen
    },
    {
      path: '/stats',
      name: 'StatsScreen',
      component: StatsScreen
    }
  ]
})
